module.exports = __webpack_public_path__ + "img/chef.03f9854d.svg";